import type { ApprovalAttributes } from '@/types/approval';
import {
  SERP_NOT_LOADED_MESSAGE,
  type SerpDocumentRef,
} from '@/utils/approval/serpDocument';

/** SERP 시즌운영계획 — 레거시 appr_edit_forms_serp_season */
export const SERP_SEASON_PLAN_TYPE = 159;

export const isSerpSeasonPlanType = (apvType: number): boolean =>
  apvType === SERP_SEASON_PLAN_TYPE;

export type SerpSeasonPlanItem = {
  SSN_CD?: unknown;
  PROD_CD?: unknown;
  COLOR_CD?: unknown;
  PROD_KO_NM?: unknown;
  DISC_PRC?: unknown;
  SALE_URC?: unknown;
  DISC_RAT?: unknown;
  [key: string]: unknown;
};

/** EAI 응답 원문 — 저장 attributes.data 에 손대지 않고 그대로 보관 */
export type SerpSeasonPlanSource = {
  APLY_DE?: unknown;
  APLY_STA_DE?: unknown;
  APLY_END_DE?: unknown;
  DTL_INFO?: { DTL_LIST?: SerpSeasonPlanItem[]; COLOR_CNT?: unknown } | null;
  DISC_INFO?: { DISC_LIST?: SerpSeasonPlanItem[]; DISC_CNT?: unknown } | null;
  RSRV_INFO?: { RSRV_LIST?: SerpSeasonPlanItem[]; RSRV_CNT?: unknown } | null;
  [key: string]: unknown;
};

export type SerpSeasonPlanDraftSource = {
  code: number;
  attributes: SerpDocumentRef;
  display: { source?: SerpSeasonPlanSource | null };
};

export type SerpSeasonPlanState = SerpDocumentRef & {
  source: SerpSeasonPlanSource;
};

export type SerpSeasonPlanSection = {
  /** 접고 펴는 영역 id — 레거시 저장 HTML 의 버튼 data-value 와 같음 */
  detailId: string;
  title: string;
  items: SerpSeasonPlanItem[];
  count: unknown;
};

const listOf = (raw: unknown): SerpSeasonPlanItem[] =>
  Array.isArray(raw) ? (raw as SerpSeasonPlanItem[]) : [];

/** 레거시 순서: 정상 → 이월 → 리저브 */
export const getSerpSeasonPlanSections = (
  source: SerpSeasonPlanSource,
): SerpSeasonPlanSection[] => [
  {
    detailId: 'detail_view_dtl',
    title: '정상 운영 스타일- 컬러리스트',
    items: listOf(source.DTL_INFO?.DTL_LIST),
    count: source.DTL_INFO?.COLOR_CNT,
  },
  {
    detailId: 'detail_view_disc',
    title: '이월 운영 스타일- 컬러리스트',
    items: listOf(source.DISC_INFO?.DISC_LIST),
    count: source.DISC_INFO?.DISC_CNT,
  },
  {
    detailId: 'detail_view_rsrv',
    title: '리저브 운영 대상 스타일- 컬러리스트',
    items: listOf(source.RSRV_INFO?.RSRV_LIST),
    count: source.RSRV_INFO?.RSRV_CNT,
  },
];

export const SERP_SEASON_PLAN_DETAIL_IDS = new Set(
  getSerpSeasonPlanSections({}).map((section) => section.detailId),
);

export const checkSerpSeasonPlanBeforeSave = (
  state: SerpSeasonPlanState | null | undefined,
): string | null => (state?.source ? null : SERP_NOT_LOADED_MESSAGE);

export const buildSerpSeasonPlanAttributes = (
  state: SerpSeasonPlanState | null | undefined,
  content: string,
): ApprovalAttributes | null =>
  state?.source
    ? {
        typeCode: state.typeCode,
        sequence: state.sequence,
        content,
        data: state.source,
      }
    : null;
